export const convertToLetters = (name: string) => {
    return name
        .split(' ')
        .filter((_, index) => index < 2)
        .map((word) => word.charAt(0))
        .join('');
}